(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .component("learningItemLearnerAccessModal", {
        templateUrl: "app/account/learnerAccess/learningItemLearnerAccessModal.component.html",
        bindings: {
            modalInstance: "<"
        },
        controller: ["assignmentLearnerAccessResource", "$stateParams", "$filter", LearningItemLearnerAccessModalCtrl],
        controllerAs: "vm"
    });
    function LearningItemLearnerAccessModalCtrl(assignmentLearnerAccessResource, $stateParams, $filter) {
        var vm = this;
        vm.contentLoaded = false;
        vm.expireDuration = "";
        vm.load = load;
        vm.requiredForRecognition = $stateParams.requiredForRecognition;
        vm.assignmentStatusClass = "assigned";
        vm.haveMultipleButtons = false;
        vm.learner = true;
        load();
        /////////////////////////////////.....
        function load() {
            if (vm.assignment)
                delete vm.assignment;
            if (vm.customView)
                delete vm.customView;
            vm.contentLoaded = false;
            assignmentLearnerAccessResource.getLearnerAccessViewModel({ number: $stateParams.number, version: $stateParams.version, code: $stateParams.code }, function (data) {
                vm.assignment = data;
                switch (data.assignmentStatus) {
                    case 0:
                        vm.assignmentStatusClass = "disabled";
                        break;
                    case 1:
                    case 2:
                        vm.assignmentStatusClass = "assigned";
                        break;
                    case 3:
                        vm.assignmentStatusClass = "completed";
                        break;
                    case 4:
                        vm.assignmentStatusClass = "expired";
                        break;
                }
                if (vm.assignment.itemExpires) {
                    vm.expireDuration = $filter("duration")(vm.assignment.itemExpireYears + ":" + vm.assignment.itemExpireMonths + ":" + vm.assignment.itemExpireDays, "yMd");
                }
            });
        }
        vm.dismiss = function () {
            vm.modalInstance.dismiss("cancel");
        };
    }
}());
